import styled from 'styled-components';

import { TableWrap as DefaultTableWrap } from './loyalty-history.styled.default';

export * from './loyalty-history.styled.default';

export const TableWrap = styled(DefaultTableWrap)`
  th {
    font-family: ${Styles.fontFamily.brand};
  }

  td {
    vertical-align: top;
  }
`;
